const getBorderRadius = ({row, col, columns, rows}:{row: number, col: number, columns: number, rows: number}): string => {
  if (columns === 1 && rows === 1) {
    return "10px"
  }

  const isFirstRow = row === 0;
  const isLastRow = row === rows - 1;
  const isFirstCol = col === 0;
  const isLastCol = col === columns - 1;

  if (rows === 1) {
    if (columns > 1) {
      if (isFirstCol) return "10px 0px 0px 10px";
      if (isLastCol) return "0px 10px 10px 0px";
    } else {
      if (isFirstCol) return "10px 10px 0px 0px";
      if (isLastCol) return "0px 0px 10px 10px";
    }
  }

  if (columns === 1) {
    if (isFirstRow) return "10px 10px 0px 0px";
    if (isLastRow) return "0px 0px 10px 10px";
  }

  if (isFirstRow && isFirstCol) return "10px 0px 0px 0px";
  if (isFirstRow && isLastCol) return "0px 10px 0px 0px";
  if (isLastRow && isFirstCol) return "0px 0px 0px 10px";
  if (isLastRow && isLastCol) return "0px 0px 10px 0px";

  return "0px";
};

export default getBorderRadius